import styled from 'styled-components';
import { useEffect } from 'react';
import Modal, {
  CloseButton,
} from '@paradigm/design-system/src/components/Modal';
import Text from '@paradigm/design-system/src/components/Text';
import {
  useDefaultAccountModalMethods,
  useDefaultAccountModalState,
} from '@paradigm/features/src/preferences/default-accounts/modal-context';
import ProBadge from '@paradigm/design-system/src/assets/ProBadge';
import { Maybe } from '@paradigm/utils/types';
import { useDefaultAccountsActions } from '@paradigm/features/src/preferences/default-accounts/context';
import { firefly_2 } from '@paradigm/design-system/src/colors';
import { TrackingCtxProvider } from '@paradigm/features/src/analytics';
import DefaultAccounts from './DefaultAccounts';

interface Props {
  onChangeDefault: (accountName: string | null) => void;
  accountSelectInfo: {
    venue: string;
    productCode: Maybe<string>;
  };
}

export default function DefaultAccountsModal(props: Props) {
  const { isOpen } = useDefaultAccountModalState();
  if (!isOpen) return null;

  return <DefaultAccountsModalContent {...props} />;
}

function DefaultAccountsModalContent({
  onChangeDefault,
  accountSelectInfo,
}: Props) {
  const { getDefaultAccount } = useDefaultAccountsActions();
  const { venue, productCode } = accountSelectInfo;
  const { close } = useDefaultAccountModalMethods();

  useEffect(() => {
    const defaultAccount = getDefaultAccount(venue, productCode);
    onChangeDefault(defaultAccount);
  }, [getDefaultAccount, onChangeDefault, productCode, venue]);

  return (
    <Modal width={500} isOpen toggle={close}>
      <TrackingCtxProvider value="default accounts">
        <Content data-testid="edit-default-account-modal">
          <Header>
            <Title>
              <ProBadge />
              <Text size="xxlarge" weight="bold">
                Default Accounts
              </Text>
            </Title>
            <CloseButton onClick={close} />
          </Header>
          <DefaultAccounts />
        </Content>
      </TrackingCtxProvider>
    </Modal>
  );
}
const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
`;

const Content = styled.div`
  background-color: ${firefly_2};
  padding: 32px 32px 20px 32px;
  border-radius: 8px;
  overflow: hidden;
`;
